import { WorkersController } from "viewer/workers/controller";

const worker = new WorkersController();

export { worker };
